
<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9196 5.90704C11.9196 9.73275 7.00079 13.0119 7.00079 13.0119C7.00079
      13.0119 2.08203 9.73275 2.08203 5.90704C2.08203 4.60251 2.60026 3.3514
      3.5227 2.42895C4.44515 1.50651 5.69626 0.988281 7.00079 0.988281C8.30533
      0.988281 9.55644 1.50651 10.4789 2.42895C11.4013 3.3514 11.9196 4.60251 11.9196 5.90704Z"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.00079 7.54663C7.90631 7.54663 8.64038 6.81256 8.64038 5.90704C8.64038
      5.00152 7.90631 4.26746 7.00079 4.26746C6.09527 4.26746 5.36121 5.00152 5.36121 5.90704C5.36121 6.81256 6.09527 7.54663 7.00079 7.54663Z"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>